import { capitalize } from 'lodash';
import {
  Button,
  CreateAlert,
  Icon,
  ObjectUtils,
  onError,
  TableScroll,
} from 'modules';
import moment from 'moment';
import React, { Fragment, memo, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { PopupWraper } from '../../../components/popup';
import {
  TableFilterInputText,
  TableFilterRangeTimeInput,
} from '../../../components/table-filter-inputs';
import { TableFilterInputSelect } from '../../../components/table-filter-inputs/select';
import { getLocaleKey, translate } from '../../../languages';
import { BankService } from '../../../services';
import { AdminService } from '../../../services/admin';
import { useSelector } from '../../../store';
import { transactionWrapper } from '../components';
const CopyToClipboardElement = CopyToClipboard as any;
export const WithdrawProgress = transactionWrapper(
  memo(() => {
    const coinsState = useSelector((state) => state.coins);
    const coinsOptions = ObjectUtils.getIn(coinsState, 'data', [], (arr) =>
      arr.map((item: any) => ({ label: item.name, value: item.coinId })),
    );

    const startOfMonth = moment().subtract(1, 'months').startOf('month');
    const endOfDay = moment().endOf('day');

    const [actionWithdraw, setActionWithdraw] = useState<any>(null);
    const [forceUpdateTable, setForceUpdateTable] = useState(false);

    return (
      <>
        <div className='WithdrawProgress'>
          <TableScroll
            hasOrderColumn
            itemPerPages={20}
            filters={[
              {
                name: 'Time',
                key: 'created',
                input: (e) => (
                  <TableFilterRangeTimeInput
                    {...e}
                    fromKey='fromDate'
                    toKey='toDate'
                  />
                ),
                defaultValue: {
                  fromDate: startOfMonth,
                  toDate: endOfDay,
                },
              },
              {
                name: 'Email',
                key: 'email',
                input: TableFilterInputText,
              },
              {
                name: 'Status',
                key: 'status',
                input: (s) => (
                  <TableFilterInputSelect
                    {...s}
                    options={BankService.getStatusOptions()}
                  />
                ),
              },
            ]}
            structure={[
              {
                name: 'Coin',
                key: 'coinId',
                render: (item) => {
                  const coin = coinsOptions.find(
                    (v: any) => v.value === item.coinId,
                  );
                  return ObjectUtils.getIn(coin, 'label', '--');
                },
              },
              {
                name: translate('time'),
                key: 'created',
                render: (item) => {
                  const date = new Date(item.created);
                  return (
                    <span>
                      {date.toLocaleTimeString(getLocaleKey())} <br />
                      {date.toLocaleDateString(getLocaleKey())}
                    </span>
                  );
                },
              },
              {
                name: 'Email',
                key: 'email',
                className: 'email',
                render: (item) => {
                  return (
                    <div>
                      <CopyToClipboardElement
                        text={item.email}
                        onCopy={() => {
                          CreateAlert({
                            message: translate('Copied'),
                            type: 'success',
                          });
                        }}
                      >
                        <div className='value'>
                          <span className='email'>{item.email}</span>
                          <span className='icon'>
                            <Icon.Copy />
                          </span>
                        </div>
                      </CopyToClipboardElement>
                    </div>
                  );
                },
              },
              {
                name: 'Value',
                key: 'value',
                render: (item) =>
                  (+item.value).toLocaleString(getLocaleKey(), {
                    maximumFractionDigits: 4,
                    minimumFractionDigits: 4,
                  }),
              },
              {
                name: 'Status',
                key: 'status',
                render: (v) => capitalize(v.status.replace(/_/g, ' ')),
              },
              {
                name: 'Actions',
                render: (item, fetchData) => {
                  return (
                    <Fragment>
                      <Button
                        className='mr5'
                        type='button'
                        buttonType='success-outline'
                        label='Approve'
                        disabled={item?.status !== 'JUST_CREATED'}
                        onClick={async () =>
                          setActionWithdraw({
                            id: item.transactionRequestId,
                            type: 'approve',
                          })
                        }
                      />

                      <Button
                        type='button'
                        buttonType='danger-outline'
                        label='Reject'
                        disabled={item?.status !== 'JUST_CREATED'}
                        onClick={async () =>
                          setActionWithdraw({
                            id: item.transactionRequestId,
                            type: 'reject',
                          })
                        }
                      />
                    </Fragment>
                  );
                },
              },
            ]}
            fetchData={async (state) => {
              const params = { ...state };
              if (params['fromDate'])
                params['fromDate'] = new Date(params['fromDate']);
              if (params['toDate'])
                params['toDate'] = new Date(params['toDate']);

              return AdminService.getListWithdrawProgress({
                page: params.pageNumber,
                numberOfItemsPerPage: params.limit,
                ...params,
              });
            }}
            forceUpdateTable={forceUpdateTable}
          />
        </div>

        {actionWithdraw && (
          <PopupWraper
            center
            title={`Confirm ${actionWithdraw.type} withdraw`}
            onClose={() => setActionWithdraw(null)}
          >
            <h2>{`Are you sure you want to ${actionWithdraw.type} withdraw?`}</h2>
            <div className='d-flex justify-content-center align-item-center mt40'>
              <Button
                label='Cancel'
                buttonType='grey'
                className='candle-control-submit-btn mr20'
                onClick={() => setActionWithdraw(null)}
              />
              <Button
                label='Submit'
                buttonType='success'
                className='candle-control-submit-btn'
                onClick={() => {
                  const service =
                    actionWithdraw.type === 'approve'
                      ? AdminService.withdrawApprove(actionWithdraw.id)
                      : AdminService.withdrawReject(actionWithdraw.id);

                  Promise.all([service])
                    .then(() => {
                      CreateAlert({
                        type: 'success',
                        message:
                          actionWithdraw.type === 'approve'
                            ? 'Approve withdraw success'
                            : 'Reject withdraw success',
                      });
                    })
                    .catch(onError)
                    .finally(() => {
                      setActionWithdraw(null);
                      setForceUpdateTable((state) => !state);
                    });
                }}
              />
            </div>
          </PopupWraper>
        )}
      </>
    );
  }),
);
